<mat-spinner mode="indeterminate"></mat-spinner>

@if (employeeFullName) {
  <span>Récupération du contrat pour {{ employeeFullName }}...</span>
} @else {
  <span>Récupération du contrat...</span>
}
